import { Map } from 'immutable';
import { constants, records } from '@saucelabs/sl-module-invitation';

import * as types from './types';

const initialState = new Map({
  invitation: new records.InvitationRecord(),
  loading: true,
});

const invitationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_INVITATION.SUCCESS:
      return state
        .set('invitation', new records.InvitationRecord(payload))
        .set('loading', false);
    case types.GET_INVITATION.FAILURE:
      return state
        .set('invitation', { status: constants.NOT_FOUND })
        .set('loading', false);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default invitationReducer;
export { initialState };
